import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon, Menu, Dropdown, Col, Input, Popover, Select, Button, Badge, Tabs } from 'antd';
import {
  TabMenuContainer,
  EmptySettingsDetails,
  LoaderContainer,
  TabMenuHeaderContainer,
  TabMenuHeader,
  TabMenuItemContainer,
  DropdownDetails,
  NoDataView,
  TabSearchContainer,
  PopoverContainer,
  ClearAll,
  NoteText,
  SearchNavWrapper,
} from '../../../containers/SidebarMenu/styles';
import EmptyElementsIllustration from '../../../images/empty-elements.svg';
import { FilterSvg } from '../../SidebarMenuIcons';
import Loader from '../../Loader';
import DeleteTemplateModal from '../../Modals/DeleteTemplateModal';
import ShortMessagePreview from './Preview';
import { getAllCategoriesByShortMessageTemplate } from '../../../utils/services/categoriesAPI';
import { searchTemplates } from '../../../utils/services/shortMessageTemplateAPI';
import AddTagsModal from '../../Modals/AddTagsModal';
// app store context API
import { AppStoreContext } from '../../../context/appStoreContext';
import TemplateDataPreview from './TemplateDataPreview';
import { useTranslation } from 'react-i18next';
import { SHORT_MESSAGE_TEMAPLTES_TAB } from './translationValues';

const { Option } = Select;
const { TabPane } = Tabs;
const NAMESPACES = ['SHORT_MESSAGE_TEMAPLTES_TAB'];
/* This component lists the short message templates
  Child Components: 
    * ShortMessagePreview
    * DeleteTemplateModal
*/

const ShortMessageTemplates = props => {
  const { isBottom } = props;
  const { t } = useTranslation(NAMESPACES);
  let history = useHistory();
  const [selectedView, setSelectedView] = useState('view-templates');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [fetchingCategories, setFetchingCategories] = useState(true);
  const [initialLoader, setInitialLoader] = useState(true);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const { categoryTemplates, updateCategoryTemplates, checkUserAccess, languageList } = useContext(
    AppStoreContext,
  );
  const [loadMore, setLoadMore] = useState(false);
  const [page, setPage] = useState(1);
  const [defaultTemplates, setDefaultTemplates] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [searchedTemplates, setSearchedTemplates] = useState({});
  const [noData, setNodata] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterOption, setFilterOption] = useState('All');
  const [selectedLanguage, setSelectedLanguage] = useState('all');
  const [pageIndex, setPageIndex] = useState(0);
  const [templateType, settemplateType] = useState(
    checkUserAccess('master') ? 'mastertemplate' : 'usertemplate',
  );

  useEffect(() => {
    if (isBottom && !loadMore && !noData) {
      if (selectedView === 'view-search-template') {
        onSearch();
      }
    }
    setDefaultTemplates(categoryTemplates);
    // eslint-disable-next-line
  }, [isBottom, categoryTemplates, templateType]);

  useEffect(() => {
    (async () => {
      const response = await getAllCategoriesByShortMessageTemplate(true, true, templateType);
      if (response && response.data) {
        setDefaultTemplates(response.data);
        updateCategoryTemplates(response.data, 'saveAllCategoryTemplates');
      }
      setFetchingCategories(false);
      setInitialLoader(false);
    })();
    // eslint-disable-next-line
  }, [templateType]);

  const updateSelectedView = (view, templateObj, action = undefined) => {
    if (view === 'view-templates') {
      setSearchKey('');
      setFilterOption('All');
      setSelectedLanguage('all');
      setSelectedCategory(undefined);
      setSearchedTemplates({});
      updateCategoryTemplates(defaultTemplates, 'saveAllCategoryTemplates');
    }
    setSelectedView(view);
    setSelectedTemplate(templateObj);
  };

  const enableModalVisibility = async (actionType, template) => {
    setSelectedTemplate(template);
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
  };

  const previewModalVisibility = (e, actionType, template, pageId) => {
    e.stopPropagation();
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedTemplate(template);
    setPageIndex(pageId);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
  };

  const redirectToTemplate = async (template, actionType, updates) => {
    history.push(`/shortMessageDesign/${template.id}`);
  };

  const onSuccessDeletion = () => {
    setSelectedView('view-templates');
    setUpdateModalVisibility(false);
  };

  const onSearch = async (first = false, category = selectedCategory, searchParam = searchKey) => {
    let currentPage = page;
    if (first) {
      setPage(1);
      currentPage = 1;
      setNodata(false);
      setFetchingCategories(true);
    }
    const payload = {
      page: currentPage,
      limit: 10,
      categoryId: category?.categoryId || '',
      ...( selectedLanguage !== 'all' && { language: selectedLanguage }),
    };
    if (searchParam !== '') {
      payload.searchParam = searchParam;
    }
    setSelectedView('view-search-template');
    setLoadMore(true);
    setFilterOption(category);
    let response = await searchTemplates(payload, templateType);
    if (response?.data) {
      const templates = response.data;
      let updatedSearchTemplates = {
        count: response.dataCount,
        templates: first ? templates : [...searchedTemplates?.templates, ...templates],
      };
      setSearchedTemplates(updatedSearchTemplates);
      if (payload.limit * currentPage >= response.dataCount) {
        setNodata(true);
      }
      setPage(currentPage + 1);
    }
    setFetchingCategories(false);
    setLoadMore(false);
  };

  const seeAllByCategory = category => {
    if (category === 'All' && selectedLanguage === 'all') {
      updateSelectedView('view-templates', null);
    } else {
      setSelectedCategory(category);
      onSearch(true, category);
    }
  };

  const onClose = () => {
    setSearchKey('');
    if (!selectedCategory) {
      updateSelectedView('view-templates', null);
    } else {
      onSearch(true, undefined, '');
    }
  };

  const onSuccessAddition = success => {
    if (success && (searchKey.length > 0 || selectedCategory)) {
      onSearch(true);
    }
    setUpdateModalVisibility(false);
  };

  const handleTemplateType = key => {
    setTimeout(() => {
      settemplateType(key);
      setFilterVisible(false);
      setFetchingCategories(true);
      updateSelectedView('view-templates', null);
    }, 300);
  };

  const renderLoader = (styles = {}) => (
    <LoaderContainer top={styles.top}>
      <Loader />
      <div className="loading-txt">
        {t(
          SHORT_MESSAGE_TEMAPLTES_TAB.LOADING_TEMPALTES.key,
          SHORT_MESSAGE_TEMAPLTES_TAB.LOADING_TEMPALTES.value,
        )}
      </div>
    </LoaderContainer>
  );

  const renderSearchBar = () => {
    return (
      <TabSearchContainer>
        <Input
          name="templateSearch"
          placeholder={t(
            SHORT_MESSAGE_TEMAPLTES_TAB.SEARCH_TEMPALTES_PLACEHOLDER.key,
            SHORT_MESSAGE_TEMAPLTES_TAB.SEARCH_TEMPALTES_PLACEHOLDER.value,
          )}
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onPressEnter={() => onSearch(true)}
          style={{ width: 200 }}
          prefix={<Icon type="search" />}
          autoComplete={'off'}
          suffix={
            <>
              {searchKey.length > 0 && <Icon type="close" onClick={onClose} />}
              <Popover
                placement="bottomRight"
                title={t(SHORT_MESSAGE_TEMAPLTES_TAB.FILTERS_TITLE.key, SHORT_MESSAGE_TEMAPLTES_TAB.FILTERS_TITLE.value)}
                trigger="click"
                visible={filterVisible}
                onVisibleChange={() => setFilterVisible(!filterVisible)}
                content={
                  <PopoverContainer>
                    <ClearAll
                      onClick={() => [
                        setFilterVisible(false),
                        updateSelectedView('view-templates', null),
                      ]}
                    >
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_TAB.CLEAR_ALL_FILTERS_ACTION.key,
                        SHORT_MESSAGE_TEMAPLTES_TAB.CLEAR_ALL_FILTERS_ACTION.value,
                      )}
                    </ClearAll>
                    <div className='ant-popover-title title' style={{ padding: '8px 0px' }}>
                      {t(SHORT_MESSAGE_TEMAPLTES_TAB.SEARCH_BY_CATEGORY_FILTER_POPUP_TITLE.key, SHORT_MESSAGE_TEMAPLTES_TAB.SEARCH_BY_CATEGORY_FILTER_POPUP_TITLE.value)}
                    </div>
                    <Select
                      showSearch
                      value={JSON.stringify(filterOption)}
                      style={{ width: 200 }}
                      placeholder={t(
                        SHORT_MESSAGE_TEMAPLTES_TAB.SELECT_CATEGORY_FILTER_PLACEHOLDER.key,
                        SHORT_MESSAGE_TEMAPLTES_TAB.SELECT_CATEGORY_FILTER_PLACEHOLDER.value,
                      )}
                      filterOption={(input, option) =>
                        option.props.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                      }
                      onChange={value => setFilterOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                        {t(
                          SHORT_MESSAGE_TEMAPLTES_TAB.SELECT_ALL_CATEGORY_DROPDOWN_OPTION.key,
                          SHORT_MESSAGE_TEMAPLTES_TAB.SELECT_ALL_CATEGORY_DROPDOWN_OPTION.value,
                        )}
                      </Option>
                      {defaultTemplates.length > 0 &&
                        defaultTemplates.map(data => (
                          <Option key={data.categoryId} value={JSON.stringify(data)}>
                            {data.categoryName}
                          </Option>
                        ))}
                    </Select>
                    <div className='ant-popover-title title' style={{ padding: '8px 0px' }}>
                      {t(SHORT_MESSAGE_TEMAPLTES_TAB.BY_LANGUAGE_LABEL.key, SHORT_MESSAGE_TEMAPLTES_TAB.BY_LANGUAGE_LABEL.value)}
                    </div>
                    <Select
                      value={selectedLanguage}
                      style={{ width: 200 }}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setSelectedLanguage(value)}
                    >
                      <Option key="all" selected>
                        {t(SHORT_MESSAGE_TEMAPLTES_TAB.SELECT_ALL_CATEGORY_DROPDOWN_OPTION.key, SHORT_MESSAGE_TEMAPLTES_TAB.SELECT_ALL_CATEGORY_DROPDOWN_OPTION.value)}
                      </Option>
                      {languageList.map((item) => {
                        return <Option value={item.code}>{item.name}</Option>
                      })}
                    </Select>
                    <Button
                      type="primary"
                      onClick={() => [setFilterVisible(false), seeAllByCategory(filterOption)]}
                    >
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_TAB.APPLY_FILTERS_BUTTON.key,
                        SHORT_MESSAGE_TEMAPLTES_TAB.APPLY_FILTERS_BUTTON.value,
                      )}
                    </Button>
                  </PopoverContainer>
                }
              >
                <Badge dot count={selectedCategory ? null : 0}>
                  <Icon component={FilterSvg} onClick={() => setFilterVisible(!filterVisible)} />
                </Badge>
              </Popover>
            </>
          }
        />
        {!fetchingCategories && selectedView === 'view-search-template' && (
          <NoteText>
            {t(SHORT_MESSAGE_TEMAPLTES_TAB.FILTERED_TEMPLATES_COUNT.key, SHORT_MESSAGE_TEMAPLTES_TAB.FILTERED_TEMPLATES_COUNT.value, {templatesCount: searchedTemplates.count})}
            
          </NoteText>
        )}
      </TabSearchContainer>
    );
  };

  const renderEmptyView = () => (
    <EmptySettingsDetails>
      <div className="empty-illustration">
        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
      </div>
    </EmptySettingsDetails>
  );

  const tabHeaderView = category => {
    return (
      <Col>
        <TabMenuHeader className={'categoryName'}>
          <h2>{category.categoryName}</h2>
        </TabMenuHeader>
        {category.templates && category.templates.length >= 4 && (
          <TabMenuHeader onClick={() => seeAllByCategory(category)}>
            <div className="see-all">
              {' '}
              {t(
                SHORT_MESSAGE_TEMAPLTES_TAB.SEE_ALL_TEMPLATES_ACTION.key,
                SHORT_MESSAGE_TEMAPLTES_TAB.SEE_ALL_TEMPLATES_ACTION.value,
              )}
            </div>
          </TabMenuHeader>
        )}
      </Col>
    );
  };

  const singleTemplate = (category, templateObj, action) => {
    let categoryByTemplate =
      action === 'view-search-template'
        ? {
            id: templateObj.id,
            name: templateObj.name,
            categoryName: templateObj?.categoryName,
            categoryId: category?.categoryId,
            tags: templateObj.tags,
          }
        : {
            id: templateObj.id,
            name: templateObj.name,
            categoryName: category?.categoryName,
            categoryId: category?.categoryId,
            tags: templateObj.tags,
          };
    templateObj.categoryName = category?.categoryName;
    return (
      <TemplateDataPreview
        templateObj={templateObj}
        onPreviewClick={e => previewModalVisibility(e, 'preview-thumbnail', templateObj, 0)}
        renderDropDown={() =>
          templateObj.permission === 'write' &&
          checkUserAccess('client') && (
            <DropdownDetails
              id={`${templateObj.id}-template`}
              className="dropdown-menu"
              onClick={e => e.stopPropagation()}
            >
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="0" onClick={() => redirectToTemplate(templateObj)}>
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_TAB.EDIT_TEMPLATE_DROPDOWN_OPTION.key,
                        SHORT_MESSAGE_TEMAPLTES_TAB.EDIT_TEMPLATE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                    <Menu.Item
                      key="1"
                      onClick={() => enableModalVisibility('delete-template', categoryByTemplate)}
                    >
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_TAB.DELETE_TEMPLATE_DROPDOWN_OPTION.key,
                        SHORT_MESSAGE_TEMAPLTES_TAB.DELETE_TEMPLATE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                    <Menu.Item
                      key="2"
                      onClick={() => enableModalVisibility('add-tag', categoryByTemplate)}
                    >
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_TAB.MANAGE_TAGS_TEMPLATE_DROPDOWN_OPTION.key,
                        SHORT_MESSAGE_TEMAPLTES_TAB.MANAGE_TAGS_TEMPLATE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                  </Menu>
                }
                trigger={['click']}
                getPopupContainer={() => document.getElementById(`${templateObj.id}-template`)}
              >
                <Icon type="more" />
              </Dropdown>
            </DropdownDetails>
          )
        }
        languageList={languageList}
      />
    );
  };

  const templateCardView = (category, action) => {
    return category.messages && category.messages.length ? (
      <TabMenuItemContainer>
        {category.messages.map(templateObj => {
          return singleTemplate(category, templateObj, action);
        })}
      </TabMenuItemContainer>
    ) : (
      <div></div>
    );
  };

  const renderCategory = () => {
    return (
      <>
        {categoryTemplates.map(category => (
          <TabMenuHeaderContainer key={category.categoryId}>
            {tabHeaderView(category)}
            {templateCardView(category, 'view-templates')}
          </TabMenuHeaderContainer>
        ))}
      </>
    );
  };

  const showMoreView = text => {
    const loaderStyles = { top: '0px' };
    return (
      <>
        {loadMore && renderLoader(loaderStyles)}
        {noData && <NoDataView small>{text}</NoDataView>}
      </>
    );
  };

  const renderSearchView = () => {
    return searchedTemplates.templates?.length > 0 ? (
      <>
        <TabMenuItemContainer>
          {searchedTemplates.templates.map(data => {
            const categoryDetails = {
              categoryId: data.categoryId,
            };
            return data.messages.map(message => {
              return singleTemplate(categoryDetails, message, 'view-search-template');
            });
          })}
        </TabMenuItemContainer>
        {showMoreView(
          t(
            SHORT_MESSAGE_TEMAPLTES_TAB.GOT_ALL_SEARCH_RESULTS.key,
            SHORT_MESSAGE_TEMAPLTES_TAB.GOT_ALL_SEARCH_RESULTS.value,
          ),
        )}
      </>
    ) : (
      <NoDataView>
        {' '}
        {t(
          SHORT_MESSAGE_TEMAPLTES_TAB.NO_TEMPLATES_FOUND_RESULT_LABEL.key,
          SHORT_MESSAGE_TEMAPLTES_TAB.NO_TEMPLATES_FOUND_RESULT_LABEL.value,
        )}
      </NoDataView>
    );
  };

  const renderTabBody = () => {
    switch (selectedView) {
      case 'view-templates':
        return renderCategory();
      case 'view-search-template':
        return renderSearchView();
      default:
        break;
    }
  };

  const renderModals = () => {
    switch (selectedAction) {
      case 'delete-template':
        return (
          <DeleteTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            targetTemplate={selectedTemplate}
            categoryType="template"
            onSucess={onSuccessDeletion}
            isShortMessageTemplate
          />
        );

      case 'add-tag':
        return (
          <AddTagsModal
            visible={updateModalVisibility}
            onCancel={success => onSuccessAddition(success)}
            target={selectedTemplate}
            isEmail={false}
            isShortMessage={true}
            isElement={false}
          />
        );

      case 'preview-thumbnail':
        return (
          <ShortMessagePreview
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            targetTemplate={selectedTemplate}
            currentIndex={pageIndex}
          />
        );
      default:
        break;
    }
  };

  return (
    <TabMenuContainer
      style={{
        marginTop:
          selectedView === 'view-templates'
            ? '50px'
            : '80px',
      }}
    >
      <SearchNavWrapper className={'hideSearch'} style={{marginTop: '70px'}}>
        {!initialLoader && (
          <>
            {checkUserAccess('client') && (
              <Tabs defaultActiveKey="usertemplate" onChange={handleTemplateType}>
                <TabPane 
                tab={t(
                  SHORT_MESSAGE_TEMAPLTES_TAB.MY_DESIGN_TEMPLATES_TAB_LABEL.key,
                  SHORT_MESSAGE_TEMAPLTES_TAB.MY_DESIGN_TEMPLATES_TAB_LABEL.value,
                )} key="usertemplate"></TabPane>
              </Tabs>
            )}
            {renderSearchBar()}
          </>
        )}
      </SearchNavWrapper>
      {fetchingCategories && renderLoader()}
      <div>
        {!fetchingCategories && (
          <div>
            {categoryTemplates.length === 0 && renderEmptyView()}
            {categoryTemplates.length > 0 && renderTabBody()}
          </div>
        )}
      </div>
      {!fetchingCategories && updateModalVisibility && selectedAction && renderModals()}
    </TabMenuContainer>
  );
};

export default ShortMessageTemplates;
